module.exports = __webpack_public_path__ + "static/media/3 03 Tulleord Na er det din tur.dbf77e59.mp3";